/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDRequestMetadata
 */
export interface IDRequestMetadata {
    /**
     * 
     * @type {string}
     * @memberof IDRequestMetadata
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof IDRequestMetadata
     */
    csrf_token?: string;
}

/**
 * Check if a given object implements the IDRequestMetadata interface.
 */
export function instanceOfIDRequestMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IDRequestMetadataFromJSON(json: any): IDRequestMetadata {
    return IDRequestMetadataFromJSONTyped(json, false);
}

export function IDRequestMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequestMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pkce_code_challenge': !exists(json, 'pkce_code_challenge') ? undefined : json['pkce_code_challenge'],
        'csrf_token': !exists(json, 'csrf_token') ? undefined : json['csrf_token'],
    };
}

export function IDRequestMetadataToJSON(value?: IDRequestMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pkce_code_challenge': value.pkce_code_challenge,
        'csrf_token': value.csrf_token,
    };
}

